import React from 'react';
import PatientFormTemplate from '../components/PatientFormTemplate';

export default function PatientGAD7Form() {
    return (
        <PatientFormTemplate formTitle="Generalised Anxiety Disorder Questionnaire (GAD-7)" />
    );
}
